import { render, staticRenderFns } from "./customerType.vue?vue&type=template&id=3645adb7&scoped=true&"
import script from "./customerType.vue?vue&type=script&lang=js&"
export * from "./customerType.vue?vue&type=script&lang=js&"
import style0 from "./customerType.vue?vue&type=style&index=0&id=3645adb7&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645adb7",
  null
  
)

export default component.exports